// extracted by mini-css-extract-plugin
export default {"main":"bzOilkKscSUSlEFPbB0p","error":"zG7gvsMe0ARwf0QTlbzo","tokenInput":"mlT1DqnhLUCS8Do76jcg"};